import "./App.css";
import { useRef } from "react";
import Inicio from "./Pantallas/Inicio/Inicio.jsx";
import Reservar from "./Pantallas/Reservar/Reservar.jsx";
import Contacto from "./Pantallas/Contacto/Contacto.jsx";
import Eventos from "./Pantallas/Eventos/Eventos.jsx";
import QuienesSomos from "./Pantallas/QuienesSomos/QuienesSomos.jsx";
import Encabezado from "./Componentes/Encabezado/Encabezado.jsx";

function App() {
  //add refs for any items going into the menu hamburguesa
  const homeRef = useRef(null);
  const quienesSomosRef = useRef(null);
  const eventosRef = useRef(null);
  const reservarRef = useRef(null);
  const contactoRef = useRef(null);

  //add labels to the nav config arrary here with the corresponding ref; this passes to Encabezado.jsx and updates the items in the menu hamburguesa when it's open
  const navSections = [
    { label: "Inicio", ref: homeRef },
    { label: "¿Quiénes somos?", ref: quienesSomosRef },
   // { label: "Eventos", ref: eventosRef },
    // { label: "Reservar", ref: reservarRef },
    { label: "Contacto", ref: contactoRef },
  ];

  return (
    <div>
      <Encabezado navSections={navSections}  />
      
      
      
      {/* <a href="https://wa.me/send/?phone=%2B529331194137&text=Hola%2C%20me%20gustaría%20hacer%20una%20reserva." target="blank" className="reserva-button">
        RESERVAR
      </a> */}
      {/* Here we gotta do something aboutthe when scroll to show  abar at the bottom for reservations */}


      <section ref={homeRef} >
        <Inicio />
      </section>

      <section ref={quienesSomosRef} >
        <QuienesSomos />
      </section>

      {/* <section ref={eventosRef} >
        <Eventos />
      </section> */}

      {/* <section ref={reservarRef} >
        <Reservar />
      </section> */}


      <section ref={contactoRef} >
        <Contacto />
      </section>
    </div>
  );
}

export default App;
